import CompanyLeaderboards from "./CompanyLeaderboards";

const CompanyDistanceLeaderboards = ({ container }) => {
  return <CompanyLeaderboards container={container} mode="distance" />;
};

export default CompanyDistanceLeaderboards;
